import { useCallback, useEffect, useState } from 'react';
import ConsultantList from '@src/cache/ConsultantList';
import useCachedSpecialitiesList from '@src/adapters/hooks/specialities/useCachedSpecialitiesList';
import ControlledDropdown from '../ControlledDropdown';
import { DropdownOption } from '../DropDown';

interface Props {
  fieldName: string;
}

function ControlledConsultantAutoComplete({ fieldName }: Props) {
  const { getList: getConsultants } = ConsultantList();
  const { getList: getSpecialities } = useCachedSpecialitiesList();
  const [available, setAvailable] = useState<DropdownOption[]>([]);

  const findConsultants = useCallback(async () => {
    const result = await getConsultants('');
    const orderedList = result.sort((a, b) =>
      a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase())
    );

    const availableConsultants: DropdownOption[] = [];

    for (const item of orderedList) {
      let specialityName = '';

      if (item.specialityId) {
        const specialities = await getSpecialities(item.specialityId);
        if (specialities && specialities.length > 0) {
          specialityName = specialities[0].name;
        }
      }

      let label = [
        item.title,
        item.lastName,
        item.firstName ? item.firstName.substring(0, 1) : '',
        specialityName ? `(${specialityName})` : '',
      ]
        .filter(Boolean)
        .join(' ');

      availableConsultants.push({
        id: item.id ? item.id : '',
        name: label,
      });
    }

    setAvailable(availableConsultants);
  }, [getConsultants, getSpecialities]);

  useEffect(() => {
    findConsultants();
  }, [findConsultants]);

  return (
    <ControlledDropdown
      fieldName={fieldName}
      label="Consultant"
      options={available}
    />
  );
}
export default ControlledConsultantAutoComplete;
